import React from 'react';
import { FormattedMessage } from 'react-intl';

const HeaderMultiPaymentEvenSplit = () => (
  <div className="modal-section modal-title text-center divider full blue">
    <div className="header-multi-payment-even-split">
      <h1>
        <FormattedMessage
          id="autoPilot.header.multiPayment.evenSplit.title"
          defaultMessage="Autopilot"
        />
      </h1>
      <FormattedMessage
        id="autoPilot.header.multiPayment.evenSplit.subtitle"
        defaultMessage="Set a threshold to automatically trigger all future payments.
          You can update it anytime.
          Without auto-pilot, you must return to trigger each payment manually."
      />
    </div>
  </div>
);

export default HeaderMultiPaymentEvenSplit;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/autopilot/header.multi-payment.even-split.js